// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml {\n  background-color: black;\n}", "",{"version":3,"sources":["styles.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,uBAAuB;AACzB","file":"styles.css","sourcesContent":["/* You can add global styles to this file, and also import other style files */\nhtml {\n  background-color: black;\n}"]}]);
// Exports
module.exports = exports;
